import styled from 'styled-components';

const SceneMarketingResultStyled = styled.div`
  flex-grow: 1;
  border-radius: 12px;
  .scene-marketing-result {
    margin: 0 ${(props) => props.theme.spacing(12 / 8)}
      ${(props) => props.theme.spacing(12 / 8)}
      ${(props) => props.theme.spacing(12 / 8)};
  }
  .date-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .icon-disabled {
    width: 18px;
    height: 18px;
    fill: rgb(189, 189, 189);
    cursor: not-allowed !important;
  }
  .disabled {
    cursor: not-allowed !important;
  }
  .icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    fill: #1565c0;
  }
  .suspend {
    width: 45px;
    height: 35px;
  }
`;

export default SceneMarketingResultStyled;
